<!--
  Układ konfiguratora pochodzi ze STRUKTURY bloku, nie z tego szablonu.

  Komponent zachowuje wyłącznie interaktywną powłokę (mat-select, obsługa kliknięć) i wiąże ją
  z węzłami odnalezionymi po `settings.viewPart`. Treść i wygląd — etykiety, pozycje list, kwota,
  przycisk, komunikat błędu — przychodzą z węzłów, które artysta może ostylować w kreatorze.
  Każdy renderowany węzeł nosi swoją klasę `uId`, bo to na niej siada CSS zbudowany z kolumny
  `styles`; bez niej style zapisane w panelu nie miałyby na czym usiąść.

  Ten sam zabieg co w `advanced-filter-select-item`: własna powłoka, treść ze struktury.

  Blok bez struktury (założony przed AT-9279, gdy typ 61 nie miał fabryki szablonu) dostaje
  układ wbudowany z dołu. Nie udajemy, że jest stylowalny — ale nie znika ze strony, bo
  zabrałby kupującemu kwotę i jedyną drogę do koszyka.
-->
<div
  class="price-configurator"
  *ngIf="pokazujeBlok"
  [ngClass]="specialBlock?.uId"
  (click)="zatrzymajAkcjeBlokuNadrzednego($event)"
  (keydown)="zatrzymajAkcjeBlokuNadrzednego($event)"
>

  <ng-container *ngIf="maStrukture; else ukladWbudowany">
    <!--
      Klasy przez `klasyWezla()`, a nie samo `uId`: to zwykły `div`, a nie `app-block`, więc
      nikt nie dołoży mu klasy zakresu `m<modelId>`. Bez niej reguły artysty postaci
      `.block_<uId>.m<modelId>` nigdy nie trafiają — to ten sam brak, który w AT-9279/AT-9301
      dotyczył wiersza opcji i panelu listy.
    -->
    <div [formGroup]="formGroup" [ngClass]="klasyWezla(wezelKontenera)" class="price-configurator__structure">

      <ng-container *ngIf="configuration">
        <!--
          Klasy węzła wzorca na KAŻDYM wierszu: szerokość, tło i obramowanie całego wiersza
          („Edycja", nazwa parametru) artysta ustawia właśnie tutaj. Bez tego reguła
          `.block_<uId>.m<modelId>` nie ma na czym usiąść i panel STYLE nie robi nic
          (AT-9301, zwrotka 25.09). Wszystkie wiersze dzielą jeden węzeł, więc i jedno stylowanie.
        -->
        <div
          *ngFor="let parametr of parametry"
          class="price-configurator__parameter"
          [ngClass]="klasyWezla(parametr.wiersz)"
        >
          <div
            *ngIf="parametr.etykieta"
            app-block
            [item]="parametr.etykieta"
            [ngClass]="parametr.etykieta.uId"
          ></div>

          <!--
            Własny dropdown zamiast mat-select: trigger i wiersze opcji to węzły struktury,
            więc artysta może je ostylować w panelu STYLE (obramowanie/tło/strzałka biorą się
            z `uId` węzłów). Wybór dalej idzie przez `FormControl.setValue` — patrz `wybierz`.
            Wzór interakcji jak w komponencie sortowania (toggle `display`, zamknięcie po
            kliknięciu poza). `#ukladWbudowany` na dole nadal używa mat-select.
          -->
          <div class="price-configurator__select">
            <!-- Trigger stylowalny: kontener (border), tekst wybranej wartości, ikona strzałki. -->
            <div
              *ngIf="parametr.trigger; else triggerZastepczy"
              app-block
              class="price-configurator__trigger"
              role="button"
              tabindex="0"
              [item]="parametr.trigger"
              [ngClass]="parametr.trigger.uId"
              [attr.aria-haspopup]="'listbox'"
              [attr.aria-expanded]="parametr.otwarty"
              (click)="przelaczPanel(parametr)"
              (keydown.enter)="przelaczPanelKlawiszem(parametr, $event)"
              (keydown.space)="przelaczPanelKlawiszem(parametr, $event)"
              (keydown.escape)="zamknijPanele()"
              (keydown.arrowdown)="otworzZFokusem(parametr, $event, true)"
              (keydown.arrowup)="otworzZFokusem(parametr, $event, false)"
            ></div>

            <!-- Stary blok bez węzła triggera: funkcjonalny, prosty trigger (niestylowalny per uId). -->
            <ng-template #triggerZastepczy>
              <div
                class="price-configurator__trigger price-configurator__trigger--fallback"
                role="button"
                tabindex="0"
                [attr.aria-haspopup]="'listbox'"
                [attr.aria-expanded]="parametr.otwarty"
                (click)="przelaczPanel(parametr)"
                (keydown.enter)="przelaczPanelKlawiszem(parametr, $event)"
                (keydown.space)="przelaczPanelKlawiszem(parametr, $event)"
                (keydown.escape)="zamknijPanele()"
                (keydown.arrowdown)="otworzZFokusem(parametr, $event, true)"
                (keydown.arrowup)="otworzZFokusem(parametr, $event, false)"
              >{{ tekstTriggera(parametr) }} ▾</div>
            </ng-template>

            <!--
              Panel opcji: pozycjonowanie z arkusza, wygląd panelu i wierszy z klasy zakresu.
              Inline `display` tylko przy zamkniętym panelu (AT-9352): otwarty bierze `display`
              z arkusza albo od artysty, bo inline `block` wygrywał z każdą regułą i wyrównanie
              opcji z panelu STYLE nie działało. Zamknięty chowamy inline, żeby reguła artysty
              z `display: flex` nie odkryła go na stałe.
              Zapasowy wygląd (tło, obramowanie) dostaje wyłącznie blok bez węzła panelu.
            -->
            <div
              class="price-configurator__options"
              role="listbox"
              [ngClass]="klasyWezla(parametr.panel)"
              [class.price-configurator__options--fallback]="!parametr.panel"
              [style.display]="parametr.otwarty ? null : 'none'"
            >
              <div
                *ngFor="let opcja of parametr.opcje"
                class="price-configurator__option"
                role="option"
                tabindex="0"
                [ngClass]="klasyWezla(parametr.optionRow)"
                [attr.aria-selected]="opcja.id === formGroup.get(parametr.klucz)?.value"
                [attr.aria-disabled]="opcja.wyprzedana"
                [class.price-configurator__option--sold-out]="opcja.wyprzedana"
                (click)="wybierz(parametr, opcja)"
                (keydown.enter)="wybierzKlawiszem(parametr, opcja, $event)"
                (keydown.space)="wybierzKlawiszem(parametr, opcja, $event)"
                (keydown.arrowdown)="nawigujOpcje($event, 1)"
                (keydown.arrowup)="nawigujOpcje($event, -1)"
                (keydown.escape)="zamknijZPanelu($event)"
              >
                <div *ngIf="opcja.wezel" app-block [item]="opcja.wezel" [ngClass]="opcja.wezel.uId"></div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="wezelCeny" app-block [item]="wezelCeny" [ngClass]="wezelCeny.uId"></div>

        <!--
          Przycisk zakupu to węzeł ze struktury, więc nie jest elementem <button>. Rolę i obsługę
          klawiatury dokładamy tutaj, żeby nie odbierać kupującemu dostępności tylko dlatego, że
          wygląd stał się konfigurowalny.
        -->
        <div
          *ngIf="wezelPrzycisku && pokazacPrzyciskZakupu"
          app-block
          role="button"
          tabindex="0"
          [item]="wezelPrzycisku"
          [ngClass]="wezelPrzycisku.uId"
          [class.price-configurator__buy--disabled]="!mozeKupic"
          [attr.aria-disabled]="!mozeKupic"
          (click)="kup()"
          (keydown.enter)="kup()"
        ></div>
      </ng-container>

      <div
        *ngIf="pokazujeBlad"
        class="price-configurator__error"
        role="alert"
        [ngClass]="klasyWezla(wezelBledu)"
        [class.price-configurator__error--fallback]="!wezelBledu"
      >
        <div
          *ngIf="wezelTekstuBledu"
          app-block
          [item]="wezelTekstuBledu"
          [ngClass]="wezelTekstuBledu.uId"
        ></div>

        <div
          *ngIf="wezelPonowienia"
          app-block
          role="button"
          tabindex="0"
          [item]="wezelPonowienia"
          [ngClass]="wezelPonowienia.uId"
          (click)="ponow()"
          (keydown.enter)="ponow()"
        ></div>
      </div>
    </div>
  </ng-container>

  <ng-template #ukladWbudowany>
    <ng-container *ngIf="configuration">
      <ng-container *ngIf="pokazujeEdycje">
        <mat-form-field class="price-configurator__parameter" appearance="outline" floatLabel="always">
          <mat-label>{{ etykietaGlownegoParametru }}</mat-label>
          <mat-select
            [value]="wybranaEdycja"
            (selectionChange)="wybierzEdycje($event.value)"
          >
            <mat-option
              *ngFor="let edycja of edycje"
              [value]="edycja.id"
              [disabled]="edycjaWyprzedana(edycja)"
              [class.price-configurator__option--sold-out]="edycjaWyprzedana(edycja)"
            >
              {{ tekst(edycja.name) }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field
          class="price-configurator__parameter"
          appearance="outline"
          floatLabel="always"
          *ngFor="let grupa of grupyOpcji"
        >
          <mat-label>{{ tekst(grupa.label) }}</mat-label>
          <mat-select
            [value]="wybranaOpcja(grupa.id)"
            (selectionChange)="wybierzOpcje(grupa.id, $event.value)"
          >
            <mat-option *ngFor="let opcja of grupa.options" [value]="opcja.id">
              {{ tekst(opcja.name) }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>

      <div class="price-configurator__price">
        <span *ngIf="cena !== null">{{ cena | number:'1.2-2' }} {{ waluta }}</span>
      </div>

      <button
        *ngIf="pokazacPrzyciskZakupu"
        type="button"
        class="price-configurator__buy"
        mat-flat-button
        [disabled]="!mozeKupic"
        (click)="kup()"
      >
        {{ etykietaPrzycisku }}
      </button>
    </ng-container>

    <div class="price-configurator__error price-configurator__error--fallback" *ngIf="pokazujeBlad" role="alert">
      <span class="price-configurator__error-text">{{ komunikatBledu | translate }}</span>
      <button
        type="button"
        class="price-configurator__retry"
        mat-stroked-button
        (click)="ponow()"
      >
        {{ 'priceConfigurator.retry' | translate }}
      </button>
    </div>
  </ng-template>
</div>
